module.exports = __webpack_public_path__ + "6b707c61/img/splash-icon.07a7c465.svg";